import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, IconButton, List, ListItem, MenuItem, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { formatoNum } from '../../lib/format';
import { Close, Folder, Save } from '@mui/icons-material';

const AntecedentesTab = ({ antecedentes, imagenes, editable, setData, handleUpdate }) => {
    // obtener formas de integracion db
    const [formas, setFormas] = useState([]);
    const getFormas = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/tipos_integracion`)
            .then(res => res.json())
            .then((respuesta) => {
                setFormas(respuesta.data);
            });
    }
    useEffect(() => {
        getFormas();
    }, []);

    const [checkedItems, setCheckedItems] = useState(antecedentes.formas_integracion.map(forma => parseInt(forma.tipo_integracion)));

    const handleCheckboxChange = (value) => {
        const updatedItems = checkedItems.includes(value)
            ? checkedItems.filter((item) => item !== value)
            : [...checkedItems, value];

        setCheckedItems(updatedItems);
        let newChecks = formas.filter(forma => updatedItems.includes(parseInt(forma.id)));
        setData({ target: { value: newChecks.map((forma) => { return { tipo_integracion: parseInt(forma.id) } }), name: 'formas_integracion' } });
        //onChange(updatedItems);
    };

    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'antecedentes';
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                }, 0);
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgurl, isNew = false) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
    }

    if (antecedentes && formas.length > 0) {
        return (
            <Box sx={{ m: 2 }}>
                <Grid container spacing={3} sx={{ my: 2 }}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Fecha y lugar en que se estableció la empresa:</Typography>
                        {editable ?
                            <TextField fullWidth name="fecha_lugar_establecimiento" value={antecedentes.fecha_lugar_establecimiento} onChange={setData} />
                            :
                            <Typography sx={{ mx: 1, mt: 2 }}>{antecedentes.fecha_lugar_establecimiento}</Typography>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6">Origen de la organización:</Typography>
                        {editable ?
                            <TextField fullWidth name="origen_antecedentes" multiline rows={3} value={antecedentes.origen_antecedentes} onChange={setData} />
                            :
                            <Typography sx={{ mx: 1, mt: 2 }}>{antecedentes.origen_antecedentes}</Typography>
                        }
                    </Grid>
                </Grid>
                <Divider />
                <Box sx={{ my: 2 }}>
                    <Typography variant="h6">Formas de integración de la empresa:</Typography>
                    {/* Pendiente con modificación al formulario */}
                    {editable ?
                        <Box>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(1)} onChange={() => handleCheckboxChange(1)} />}
                                    label={<MenuItem>Vecinos</MenuItem>}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(2)} onChange={() => handleCheckboxChange(2)} />}
                                    label={<MenuItem>Asoc. de productores</MenuItem>}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(3)} onChange={() => handleCheckboxChange(3)} />}
                                    label={<MenuItem>Iglesia</MenuItem>}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(4)} onChange={() => handleCheckboxChange(4)} />}
                                    label={<MenuItem>Promoción de técnicos</MenuItem>}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(5)} onChange={() => handleCheckboxChange(5)} />}
                                    label={<MenuItem>Promoción de ONGs</MenuItem>}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(6)} onChange={() => handleCheckboxChange(6)} />}
                                    label={<MenuItem>Gobierno local</MenuItem>}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={checkedItems.includes(7)} onChange={() => handleCheckboxChange(7)} />}
                                    label={<MenuItem>Otro</MenuItem>}
                                />
                            </FormGroup>
                        </Box>
                        :
                        <List sx={{ listStyleType: 'disc', ml: 4 }}>
                            {antecedentes.formas_integracion.map((forma, index) => {
                                let f = formas.filter(f => f.id == forma.tipo_integracion)[0];
                                return (
                                    <ListItem sx={{ display: 'list-item' }}>
                                        <Typography>
                                            {(f.nombre)}
                                        </Typography>
                                    </ListItem>
                                )
                            })}
                        </List>
                    }
                </Box>
                <Divider />
                <Box sx={{ my: 2, display: { lg: 'flex', xs: 'block' } }}>
                    {/* Año de inicio */}
                    <Grid item xs={12} lg={3} sx={{ mr: 2 }}>
                        <Box sx={{ width: '100%' }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>Año de inicio:</Typography>
                            {editable ?
                                <TextField name="fecha_inicio_integracion" value={antecedentes.fecha_inicio_integracion} onChange={setData} />
                                :
                                <Typography sx={{ mx: 1 }}>{antecedentes.fecha_inicio_integracion}</Typography>
                            }
                        </Box>
                    </Grid>
                    {/*  */}
                    {/* Socios de la organización en sus orígenes */}
                    <Grid item xs={12} lg={9} sx={{ width: '100%' }}>
                        <Box>
                            <Typography variant="h6" sx={{ mb: 2 }}>Socios de la organización en sus orígenes</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} lg>
                                    {editable ?
                                        <TextField type="number" label="Hombres" name="socios_hombres_iniciales" value={antecedentes.socios_hombres_iniciales} onChange={setData} />
                                        :
                                        <>
                                            <Typography textAlign="center">Hombres</Typography>
                                            <Typography textAlign="center" sx={{ mx: 1 }}>{formatoNum(antecedentes.socios_hombres_iniciales)}</Typography>
                                        </>
                                    }
                                </Grid>
                                <Grid item xs={12} lg>
                                    {editable ?
                                        <TextField type="number" label="Mujeres" name="socios_mujeres_iniciales" value={antecedentes.socios_mujeres_iniciales} onChange={setData} />
                                        :
                                        <>
                                            <Typography textAlign="center">Mujeres</Typography>
                                            <Typography textAlign="center" sx={{ mx: 1 }}>{formatoNum(antecedentes.socios_mujeres_iniciales)}</Typography>
                                        </>
                                    }
                                </Grid>
                                <Grid item xs={12} lg>
                                    {editable ?
                                        <TextField type="number" label="Familias totales" name="familias_participantes" value={antecedentes.familias_participantes} onChange={setData} />
                                        :
                                        <>
                                            <Typography textAlign="center">Familias totales</Typography>
                                            <Typography textAlign="center" sx={{ mx: 1 }}>{formatoNum(antecedentes.familias_participantes)}</Typography>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Box>
                <Divider />
                <Typography sx={{ my: 2 }} variant="h6">Fotogalería de las primeras sesiones de la empresa:</Typography>
                <Grid container spacing={2}>
                    {!editable && Object.values(imagenes)
                        .filter((i) => i.paso === 'antecedentes')
                        .map((img, index) => {
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    key={index}
                                    sx={{ display: 'flex', justifyContent: 'center' }}
                                >
                                    <img
                                        src={img.url_img ?? img.dataurl}
                                        width="100%"
                                        alt={index}
                                        style={{ maxWidth: '300px', objectFit: 'contain' }}
                                    />
                                </Grid>
                            )
                        })}
                </Grid>
                {editable &&
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                            {Object.values(imagenes).filter((i) => i.paso == 'antecedentes').map((image, index) => (
                                <Grid
                                    item
                                    md={4}
                                    key={index}
                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => image.url_img ? removeImg(image.url_img) : removeImg(image.dataurl, true)}>
                                        <Close />
                                    </IconButton>
                                    <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button
                                    disabled={imagenes.filter((i) => i.paso == 'antecedentes').length > 2}
                                    component="label"
                                    variant="contained"
                                    startIcon={<Folder />}
                                >
                                    Agregar <input name="imagenes" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                }

                {/* Boton para actualizar datos de este tab. (Excepto imagenes, se actualizaran al vuelo) */}
                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }
            </Box>

        )
    }
}

export default AntecedentesTab;